import { AttachmentTile } from "@ext/agent/components/panel/AttachmentTile";
import { getAttachmentIcon } from "@ext/agent/components/utils/attachment";
import { Icon } from "@ui-kit/Icon";
import { TextOverflowTooltip } from "@ui-kit/Tooltip";

type Props = {
	name: string;
	mime: string;
	onRemove?: () => void;
};

export const FileAttachmentTile = ({ name, mime, onRemove }: Props) => (
	<AttachmentTile onRemove={onRemove}>
		<div className="flex size-full flex-col items-center justify-center gap-1.5 px-2 text-muted">
			<Icon className="size-6" icon={getAttachmentIcon(mime)} />
			<TextOverflowTooltip className="text-xs text-primary-fg">{name}</TextOverflowTooltip>
		</div>
	</AttachmentTile>
);
